import { createSlice } from "@reduxjs/toolkit"
import { ContractType, OrderDetailType, OrderListType } from "./Types";

type initialStateType = {
    fetchedOrdersPartnerID: number;
    allOrders: OrderListType[],
    fetchedContractsPartnerID: number;
    contracts: Array<ContractType>;
    orderDetail: OrderDetailType,
    orderDetailPDF: OrderDetailType,
    status: {
        orderDetailLoading: boolean,
        orderDetailPDFLoading: boolean,
        orderHistoryLoading: boolean,
        contractsLoading: boolean,
        customerDetailLoading: boolean,
        customerUpdateLoading: boolean,
        subscriptionLoading: boolean,
        updateContractLoading: boolean,
        error: boolean,
        errorMessage: string,
        errorType: string,
    },
    orderDetailPDFID: string,
    subscriptionStatus: string,
    subscriptionID: string,
}

var initialState: initialStateType = {
    fetchedOrdersPartnerID: 0,
    allOrders: [],
    fetchedContractsPartnerID: 0,
    orderDetail: {},
    orderDetailPDF: {},
    contracts: [],
    status: {
        error: false,
        orderDetailPDFLoading: false,
        orderHistoryLoading: false,
        contractsLoading: false,
        customerDetailLoading: false,
        customerUpdateLoading: false,
        subscriptionLoading: false,
        updateContractLoading: false,
        errorMessage: "",
        errorType: "",
        orderDetailLoading: false
    },
    orderDetailPDFID: "",
    subscriptionStatus: "",
    subscriptionID: "",
}

const myAccount = createSlice({
    name: "my-account",
    initialState: initialState,
    reducers: {
        setContracts: (state, action) => {
            state.contracts = action.payload;
        },
        setFetchedContractsPartnerID: (state, action) => {
            state.fetchedContractsPartnerID = action.payload;
        },
        setAllOrders: (state, action) => {
            state.allOrders = action.payload;
        },
        setFetchedOrdersPartnerID: (state, action) => {
            state.fetchedOrdersPartnerID = action.payload;
        },
        setOrderDetail: (state, action) => {
            state.orderDetail = action.payload;
        },
        setOrderDetailLoadingStatus: (state, action) => {
            state.status.orderDetailLoading = action.payload;
        },
        setOrderHistoryLoadingStatus: (state, action) => {
            state.status.orderHistoryLoading = action.payload;
        },
        setContractsLoadingStatus: (state, action) => {
            state.status.contractsLoading = action.payload;
        },
        setCustomerDetailLoadingStatus: (state, action) => {
            state.status.customerDetailLoading = action.payload;
        },
        setCustomerUpdateLoadingStatus: (state, action) => {
            state.status.customerUpdateLoading = action.payload;
        },
        setOrderDetailPDF: (state, action) => {
            state.orderDetailPDF = action.payload;
        },
        setOrderDetailPDFLoadingStatus: (state, action) => {
            state.status.orderDetailPDFLoading = action.payload;
        },
        setOrderDetailPDFID: (state, action) => {
            state.orderDetailPDFID = action.payload;
        },
        setSubscriptionLoading: (state, action) => {
            state.status.subscriptionLoading = action.payload;
        },
        setSubscriptionID: (state, action) => {
            state.subscriptionID = action.payload;
        },
        setSubscriptionStatus: (state, action) => {
            state.subscriptionStatus = action.payload;
        },
        setUpdateContractLoadingStatus: (state, action) => {
            state.status.updateContractLoading = action.payload;
        },
        reset : (state) => {
            state.fetchedOrdersPartnerID = 0;
            state.allOrders = [];
            state.fetchedContractsPartnerID = 0;
            state.contracts = [];
            state.orderDetail = {};
        }
    }
})

export const myAccountSliceReducer = myAccount.reducer;
export const myAccountSliceAction = myAccount.actions;
